import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommonProjectType } from "../../Types/HeyTraderTypes/CommonProjectType";
import { getCommonProjects } from "../../Thunks/HeyTraderThunks";

interface CommonProjectSliceState {
  loader: boolean;
  projectList: CommonProjectType[];
  errorDisplay: string | null;
}

const initialState: CommonProjectSliceState = {
  loader: false,
  projectList: [],
  errorDisplay: '',
}

const commonProjectSlice = createSlice({
  name: 'projectList',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(getCommonProjects.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })
      .addCase(getCommonProjects.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(getCommonProjects.fulfilled, (state, action: PayloadAction<CommonProjectType[]>) => {
        state.loader = false;
        state.projectList = action.payload;
      })
  }
})

export default commonProjectSlice.reducer

